import styled from 'styled-components';

export default styled.div`
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '100%'};
  ${({ border }) => (border ? `border: ${border}` : ``)};
  ${({ l }) => (l ? `border-left: ${l}` : ``)};
  ${({ r }) => (r ? `border-right: ${r}` : ``)};
  ${({ t }) => (t ? `border-top: ${t}` : ``)};
  ${({ b }) => (b ? `border-bottom: ${b}` : ``)};
`;
